
    import '/mnt/src/components/Input/index.md?watch=parent';
    export const demoIndex = {
  ids: ["input-demo-basicdemo","input-demo-advanceddemo","input-demo-demo3"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Input/index.md?type=demo')
};